import uuid from 'uuid/v1';
import supportsLocalStorage from '../utils/supportsLocalStorage';

const storageKey = 'redux-tab-sync';

export default whitelist => store => {
  if (!supportsLocalStorage()) {
    return next => action => next(action);
  }

  window.addEventListener('unload', () => {
    localStorage.removeItem(storageKey);
  });

  let lastActionUid = null;
  window.addEventListener('storage', () => {
    let storedAction = null;
    try {
      storedAction = JSON.parse(localStorage.getItem(storageKey));
    } catch (e) {
      // Intentionally blank
    }

    if (
      storedAction
      && storedAction.meta
      && storedAction.meta.syncUid !== lastActionUid
      && storedAction.meta.syncChannel === store.getState().channels.activeChannel
    ) {
      lastActionUid = storedAction.meta.syncUid;
      store.dispatch(storedAction);
    }
  });

  return next => action => {
    if (whitelist.includes(action.type) && !(action.meta && action.meta.syncUid === lastActionUid)) {
      lastActionUid = uuid();
      action = {
        ...action,
        meta: {
          ...(action.meta || {}),
          syncUid: lastActionUid,
          syncChannel: store.getState().channels.activeChannel
        }
      };

      localStorage.setItem(
        storageKey,
        JSON.stringify(action)
      );
    }

    next(action);
  };
}



// WEBPACK FOOTER //
// ./middlewares/tabSync.js